(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boreal-agencies-units"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('boreal-agencies-panel')) {
    class BorealAgenciesPanel extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('[data-agencies-toggle]');
        this.supportPanel = this.querySelector('[data-agencies-support]');
        this.backButton = this.querySelector('[data-agencies-back]');

        if (!this.toggleButton || !this.supportPanel) return;

        const showPreview = () => {
          if (!this.classList.contains('is-open')) this.classList.add('is-previewing');
        };

        const hidePreview = () => {
          this.classList.remove('is-previewing');
        };

        this.toggleButton.addEventListener('pointerenter', showPreview);
        this.toggleButton.addEventListener('pointerleave', hidePreview);
        this.toggleButton.addEventListener('focus', showPreview);
        this.toggleButton.addEventListener('blur', hidePreview);

        const setOpen = (isOpen, restoreFocus = false) => {
          this.classList.toggle('is-open', isOpen);
          this.toggleButton.setAttribute('aria-expanded', String(isOpen));
          this.supportPanel.setAttribute('aria-hidden', String(!isOpen));
          this.supportPanel.toggleAttribute('inert', !isOpen);

          if (restoreFocus) this.toggleButton.focus({ preventScroll: true });
        };

        this.toggleButton.addEventListener('click', () => {
          hidePreview();
          setOpen(!this.classList.contains('is-open'));
        });

        this.backButton?.addEventListener('click', () => setOpen(false, true));
      }
    }

    customElements.define('boreal-agencies-panel', BorealAgenciesPanel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boreal-built-for-field"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('boreal-field-story')) {
    class BorealFieldStory extends HTMLElement {
      connectedCallback() {
        this.drawer = this.querySelector('[data-field-drawer]');
        this.drawerToggle = this.querySelector('[data-field-drawer-toggle]');
        this.drawerContent = this.querySelector('[data-field-drawer-content]');
        this.triggers = Array.from(this.querySelectorAll('[data-field-trigger]'));
        this.dots = Array.from(this.querySelectorAll('[data-field-dot]'));
        this.panels = Array.from(this.querySelectorAll('[data-field-media]'));
        this.mobileQuery = window.matchMedia('(max-width: 767px)');
        this.setDrawerState(!this.mobileQuery.matches);
        this.drawerToggle.addEventListener('click', () => this.toggleDrawer());
        this.triggers.forEach((trigger) => {
          trigger.addEventListener('mouseenter', () => this.activate(trigger.dataset.fieldTrigger));
          trigger.addEventListener('focus', () => this.activate(trigger.dataset.fieldTrigger));
          trigger.addEventListener('click', () => this.activate(trigger.dataset.fieldTrigger));
        });
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.activate(dot.dataset.fieldDot));
        });
        this.swipeController?.abort();
        this.swipeController = new AbortController();
        const media = this.querySelector('.boreal-field__media');
        const swipeOptions = { passive: true, signal: this.swipeController.signal };
        media.addEventListener('touchstart', (event) => {
          this.swipeStart = null;
          if (!this.mobileQuery.matches || this.drawer.classList.contains('is-open') || event.touches.length !== 1) return;
          const touch = event.touches[0];
          this.swipeStart = { x: touch.clientX, y: touch.clientY, id: touch.identifier };
        }, swipeOptions);
        media.addEventListener('touchmove', (event) => {
          if (!this.swipeStart) return;
          const touch = event.touches[0];
          if (event.touches.length !== 1 || !touch) {
            this.swipeStart = null;
            return;
          }
          const dx = Math.abs(touch.clientX - this.swipeStart.x);
          const dy = Math.abs(touch.clientY - this.swipeStart.y);
          // Once the gesture becomes a page scroll, it must not change photos.
          if (dy > 10 && dy >= dx) this.swipeStart = null;
        }, swipeOptions);
        media.addEventListener('touchcancel', () => { this.swipeStart = null; }, swipeOptions);
        media.addEventListener('touchend', (event) => {
          const start = this.swipeStart;
          this.swipeStart = null;
          if (!start || event.touches.length || !this.mobileQuery.matches || this.drawer.classList.contains('is-open')) return;
          const touch = Array.from(event.changedTouches).find((item) => item.identifier === start.id);
          if (!touch) return;
          const dx = touch.clientX - start.x;
          const dy = touch.clientY - start.y;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3 || this.panels.length < 2) return;
          const current = this.panels.findIndex((panel) => panel.classList.contains('is-active'));
          const next = (current + (dx < 0 ? 1 : -1) + this.panels.length) % this.panels.length;
          this.activate(this.panels[next].dataset.fieldMedia);
        }, swipeOptions);
      }

      disconnectedCallback() {
        this.swipeController?.abort();
        this.swipeStart = null;
      }

      toggleDrawer() {
        this.setDrawerState(!this.drawer.classList.contains('is-open'));
      }

      setDrawerState(open) {
        this.classList.toggle('is-drawer-open', open);
        this.drawer.classList.toggle('is-open', open);
        this.drawerToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.drawerContent.inert = !open;
      }

      async activate(id) {
        const nextPanel = this.panels.find((panel) => panel.dataset.fieldMedia === id);
        if (!nextPanel) return;
        this.requestedId = id;
        const image = nextPanel.querySelector('img');
        try {
          if (image) {
            image.loading = 'eager';
            await image.decode();
          }
        } catch (error) {
          // Keep the current photo and selection if the requested image cannot load.
          return;
        }
        if (this.requestedId !== id || !this.isConnected) return;

        this.dots.forEach((dot) => {
          dot.setAttribute('aria-pressed', dot.dataset.fieldDot === id ? 'true' : 'false');
        });
        this.triggers.forEach((trigger) => {
          const active = trigger.dataset.fieldTrigger === id;
          trigger.classList.toggle('is-active', active);
          trigger.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.panels.forEach((panel) => {
          const active = panel.dataset.fieldMedia === id;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      }
    }
    customElements.define('boreal-field-story', BorealFieldStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tactical-details"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-handcuff-fits-link]');
    if (!link) return;
    const cards = Array.from(document.querySelectorAll('.boreal-handcuff-fits'));
    const mobileCard = cards.find((card) => card.closest('details'));
    const desktopCard = cards.find((card) => !card.closest('details'));
    let target;
    if (mobileCard && mobileCard.closest('details').getClientRects().length) {
      mobileCard.closest('details').open = true;
      target = mobileCard;
    } else if (desktopCard) {
      const tabs = desktopCard.closest('boreal-tactical-tabs');
      tabs?.querySelector('[data-tab="fits"]')?.click();
      target = desktopCard;
    }
    if (!target) return;
    event.preventDefault();
    target.focus({ preventScroll: true });
    target.scrollIntoView({ block: 'center', behavior: 'instant' });
  });

  if (!customElements.get('boreal-tactical-tabs')) {
    class BorealTacticalTabs extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.selectTab(button));
          button.addEventListener('keydown', (event) => this.handleKeydown(event, button));
        });
      }

      selectTab(button) {
        this.buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.panel !== button.dataset.tab;
        });
        button.focus();
      }

      handleKeydown(event, button) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const currentIndex = this.buttons.indexOf(button);
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (currentIndex + direction + this.buttons.length) % this.buttons.length;
        this.selectTab(this.buttons[nextIndex]);
      }
    }
    customElements.define('boreal-tactical-tabs', BorealTacticalTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
